import { Box, Grid } from '@material-ui/core';
import { useQuery, useUserStore } from '@roc/feature-app-core';
import { SupportRoles } from '@roc/feature-utils';
import {
  Button,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useInternalSecondAppraisalStore } from '../hooks';
import { SecondAppraisalStep } from '../stores';
import {
  SecondAppraisalError,
  SecondAppraisalForm,
  SecondAppraisalLinkSuccessAlreadyPaid,
  SecondAppraisalPaidInAdvance,
  SecondAppraisalSuccess,
} from './SecondAppraisalForm';


export const SecondAppraisalSteps = observer(({ loanId }) => {

  const { internalSecondAppraisalStore } = useInternalSecondAppraisalStore();
  const { userStore } = useUserStore();
  const [showGenerateLinkButton, setShowGenerateLinkButton] = useState(true);
  const { step } = internalSecondAppraisalStore;

  useEffect(() => {
    internalSecondAppraisalStore.fetchLoanPropertiesAndCheckStatus(loanId);
  }, [loanId]);

  const query = useQuery();

  // Check if user has tech role
  const isTechUser = userStore?.userInformation?.roles?.includes(SupportRoles.TECH) ||
    userStore?.userInformation?.roles?.includes(SupportRoles.TECH_ADMIN);

  return (
    <Box marginTop={2} marginBottom={2} marginLeft={7} marginRight={7}>
      <Grid container spacing={2} style={{ width: '100%' }} >
        <Box width="100%">
          {(step === SecondAppraisalStep.SELECT_PROPERTY) && (
            <SecondAppraisalForm />
          )}
          {step === SecondAppraisalStep.ERROR && <SecondAppraisalError />}
          {step === SecondAppraisalStep.ALREADY_PAID && (
            <SecondAppraisalPaidInAdvance />
          )}
          {step === SecondAppraisalStep.SUCCESS && (
            <SecondAppraisalSuccess />
          )}
          {step === SecondAppraisalStep.SUCCESS_ALREADY_PAID && (
            <SecondAppraisalLinkSuccessAlreadyPaid />
          )}
          {step === SecondAppraisalStep.ORDER_CREATED && (
            <SecondAppraisalPaidInAdvance />
          )}
        </Box>

        {step === SecondAppraisalStep.SELECT_PROPERTY && showGenerateLinkButton && (
          <Grid item>
            <Button
              onClick={() => {
                internalSecondAppraisalStore.orderSecondAppraisal(
                  loanId,
                  false
                );
              }}
              variant="contained"
              color="primary"
              testId="close"
            >
              Generate Link
            </Button>
          </Grid>
        )}
        {(internalSecondAppraisalStore.allowOrderSecondAppraisal && step === SecondAppraisalStep.ALREADY_PAID && isTechUser) && (
          <Grid item>
            <Button
              onClick={() => {
                internalSecondAppraisalStore.orderSecondAppraisal(
                  loanId,
                  true
                );
              }}
              variant="contained"
              color="primary"
              testId="close"
            >
              Place Order
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
});
